<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>I am indebted to my wife, Suzanne Groves, for carefully editing and “humanising” a draft manuscript. I would also like to thank Liang Zhang who provided advice on the authenticity of the behaviour and customs of the Chinese characters portrayed in the novel.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?8826f4ec